import apiClient from "./axios"

export const getShowrooms = async (params = {}) => {
  const { data } = await apiClient.get("/showrooms", { params })
  return data
}

export const getShowroom = async id => {
  const { data } = await apiClient.get(`/showrooms/${id}`)
  return data
}

export const getShowroomBySlug = async (slug, params = {}) => {
  const { data } = await apiClient.get(`/showrooms/slug/${slug}`, { params })
  return data
}

export const createShowroom = async showroomData => {
  const { data } = await apiClient.post("/showrooms", showroomData)
  return data
}

export const editShowroom = async ({ id, ...showroomData }) => {
  const { data } = await apiClient.patch(`/showrooms/${id}`, showroomData)
  return data
}

export const deleteShowroom = async id => {
  const { data } = await apiClient.delete(`/showrooms/${id}`)
  return data
}
